'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _TextBubble = require('./TextBubble');

var _TextBubble2 = _interopRequireDefault(_TextBubble);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
    _inherits(Tooltip, _Component);

    function Tooltip() {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).apply(this, arguments));

        _this.isMouseOverTooltip = null;
        _this.onBubbleComponentRef = function (ref) {
            _this.tooltipBubble = ref;
            return _this.tooltipBubble;
        };
        _this.toggleTooltip = function (ev) {
            var _ev$target$getBoundin = ev.target.getBoundingClientRect(),
                x = _ev$target$getBoundin.left,
                y = _ev$target$getBoundin.top;

            _this.tooltipBubble.setState(function (prevState) {
                return { show: !prevState.show, position: { x: x, y: y } };
            });
        };
        _this.showTooltip = function (ev) {
            var _ev$target$getBoundin2 = ev.target.getBoundingClientRect(),
                x = _ev$target$getBoundin2.left,
                y = _ev$target$getBoundin2.top;

            _this.tooltipBubble.setState({ show: true, position: { x: x, y: y } });
        };
        _this.hideTooltipBubble = function () {
            _this.tooltipBubble.setState({ show: false });
        };
        _this.onMouseEntersTrigger = function (ev) {
            _this.onMouseEntersTooltip();
            _this.showTooltip(ev);
        };
        _this.onMouseLeavesTrigger = function () {
            _this.onMouseLeavesTooltip();
            var isInteractive = _this.props.isInteractive;

            if (!isInteractive) {
                _this.hideTooltipBubble();
            }
        };
        _this.onMouseEntersTooltip = function () {
            var isInteractive = _this.props.isInteractive;

            if (!isInteractive) {
                return;
            }
            _this.isMouseOverTooltip = true;
        };
        _this.onMouseLeavesTooltip = function () {
            var isInteractive = _this.props.isInteractive;

            if (!isInteractive) {
                return;
            }
            var mouseTravelTime = 200;
            _this.isMouseOverTooltip = false;
            setTimeout(function () {
                if (!_this.isMouseOverTooltip) {
                    _this.hideTooltipBubble();
                }
            }, mouseTravelTime);
        };
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.tooltipContainer = document.createElement('div');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.appendChild(this.tooltipContainer);
            window.addEventListener('scroll', this.hideTooltipBubble);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.tooltipContainer.remove();
            window.removeEventListener('scroll', this.hideTooltipBubble);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                iconContainerClassName = _props.iconContainerClassName,
                tooltipIcon = _props.tooltipIcon,
                tooltipVerticalAlignment = _props.tooltipVerticalAlignment,
                tooltipHorizontalAlignment = _props.tooltipHorizontalAlignment,
                backgroundColor = _props.backgroundColor,
                tooltipBubbleArrowClassName = _props.tooltipBubbleArrowClassName,
                tooltipBubbleContentClassName = _props.tooltipBubbleContentClassName,
                tooltipBubbleClassName = _props.tooltipBubbleClassName,
                borderColor = _props.borderColor,
                bubbleDistance = _props.bubbleDistance,
                children = _props.children;

            return _react2.default.createElement("div", { className: className }, _react2.default.createElement("span", { className: (0, _classnames3.default)(_defineProperty({
                    'luna-tooltipIcon': typeof tooltipIcon !== 'string'
                }, iconContainerClassName, typeof iconContainerClassName === 'string')), onClick: this.toggleTooltip, onMouseEnter: this.onMouseEntersTrigger, onMouseLeave: this.onMouseLeavesTrigger, role: "button", onKeyDown: this.toggleTooltip }, tooltipIcon || _react2.default.createElement("i", { className: "icon-question-solid" })), (0, _reactDom.createPortal)(_react2.default.createElement(_TextBubble2.default, { borderColor: borderColor, verticalAlignment: tooltipVerticalAlignment, horizontalAlignment: tooltipHorizontalAlignment, backgroundColor: backgroundColor, arrowClassName: tooltipBubbleArrowClassName, bubbleContentClassName: tooltipBubbleContentClassName, className: tooltipBubbleClassName, componentRef: this.onBubbleComponentRef, onMouseEntersTooltip: this.onMouseEntersTooltip, onMouseLeavesTooltip: this.onMouseLeavesTooltip, distanceFromTooltipMarker: bubbleDistance }, children), this.tooltipContainer));
        }
    }]);

    return Tooltip;
}(_react.Component);

exports.default = Tooltip;

Tooltip.propTypes = {
    borderColor: _propTypes2.default.string.isRequired,
    tooltipVerticalAlignment: _propTypes2.default.oneOf(['top', 'bottom']).isRequired,
    tooltipHorizontalAlignment: _propTypes2.default.oneOf(['left', 'right']).isRequired,
    backgroundColor: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    iconContainerClassName: _propTypes2.default.string,
    tooltipIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
    tooltipBubbleClassName: _propTypes2.default.string.isRequired,
    tooltipBubbleArrowClassName: _propTypes2.default.string.isRequired,
    tooltipBubbleContentClassName: _propTypes2.default.string.isRequired,
    bubbleDistance: _propTypes2.default.number.isRequired,
    isInteractive: _propTypes2.default.bool,
    children: _propTypes2.default.node.isRequired
};
Tooltip.defaultProps = {
    className: undefined,
    iconContainerClassName: '',
    isInteractive: false
};
//# sourceMappingURL=Tooltip.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tooltip/Tooltip.js